export default {
  title: 'Mijn documenten',
  description: 'Uw geüploade bedrijfsdocumenten. U kunt ze op elk moment downloaden of vervangen.',
  document_types: {
    owner_document: 'Identiteitsdocument eigenaar',
    business_document: 'Bedrijfsdocument',
  },
  kinds: {
    vat_registration: 'BTW-registratie',
    trade_registration: 'Handelsregistratie',
    trade_license: 'Handelsvergunning',
    commercial_register_extract: 'Uittreksel handelsregister',
    financial_statements: 'Jaarrekeningen',
    bank_statement: 'Bankafschrift',
    shareholder_list: 'Lijst van aandeelhouders',
    other: 'Overig',
    passport: 'Paspoort',
    driver_license: 'Rijbewijs',
    id_card: 'Identiteitskaart',
    residence_permit: 'Verblijfsvergunning',
  },
  sides: {
    front: 'Voorkant',
    back: 'Achterkant',
  },
  fields: {
    slot: 'Categorie',
    document: 'Document',
    kind: 'Soort',
    side: 'Zijde',
    uploaded_at: 'Geüpload',
    expires_at: 'Verloopt',
    retained_until: 'Bewaard tot',
    deleted_at: 'Verwijderd',
    storage_deleted_at: 'Permanent verwijderd',
    actions: 'Acties',
  },
  values: {
    no_slot: 'Overig',
    no_file_name: '—',
    version: 'v{{version}}',
  },
  filters: {
    type_placeholder: 'Filteren op documenttype',
    kind_placeholder: 'Filteren op soort',
  },
  retention: {
    deletable: 'Verwijderbaar',
    tooltip:
      'De Duitse wet (GoBD / §147 AO) verplicht ons dit document te bewaren tot {{date}}. Het kan pas daarna worden verwijderd.',
    tooltip_no_date: 'Dit document valt onder een wettelijke bewaartermijn en kan nog niet worden verwijderd.',
  },
  buttons: {
    upload: 'Uploaden',
    upload_other: 'Ander document',
    retry_slots: 'Documenten konden niet worden geladen — probeer het opnieuw',
    download: 'Downloaden',
    download_front: 'Voorzijde downloaden',
    download_back: 'Achterzijde downloaden',
    reupload: 'Opnieuw uploaden',
    delete: 'Verwijderen',
  },
  empty: 'U heeft nog geen documenten geüpload.',
  delete_modal: {
    title: 'Document verwijderen',
    description:
      'Kies hoe u dit document wilt verwijderen. „Verwijderen" archiveert het en verbergt het uit uw lijst. „Definitief verwijderen" wist de bestanden onherroepelijk en is alleen mogelijk na het verstrijken van de wettelijke bewaartermijn.',
    delete: 'Verwijderen',
    permanently_delete: 'Definitief verwijderen',
    cancel: 'Annuleren',
    retention_alert:
      'Deze documenten vallen onder wettelijke bewaartermijnen op grond van Duits recht (GoBD / §147 AO). Definitief verwijderen wist de bestanden onherroepelijk.',
  },
  reupload_modal: {
    title: 'Document opnieuw uploaden',
    description: 'Upload een nieuwe versie van dit document. De vorige versie wordt vervangen.',
    type: {
      label: 'Documenttype',
      placeholder: 'Selecteer documenttype',
    },
    kind: {
      label: 'Documentsoort',
      placeholder: 'Selecteer documentsoort',
    },
    front: {
      label: 'Voorzijde document',
    },
    back: {
      label: 'Achterzijde document (optioneel voor sommige documenten)',
    },
    expires_at: {
      label: 'Vervaldatum document',
      placeholder: 'Selecteer vervaldatum',
    },
    buttons: {
      select_file: 'Bestand selecteren',
      submit: 'Uploaden',
      cancel: 'Annuleren',
    },
  },
  toasts: {
    download_error: 'Het document kon niet worden gedownload.',
    delete_success: 'Document succesvol verwijderd.',
    delete_error: 'Het document kon niet worden verwijderd.',
    reupload_success: 'Document succesvol geüpload.',
    reupload_error: 'Het document kon niet worden geüpload.',
  },
};
